const storedToken = localStorage.getItem('token');
const storedRefreshToken = localStorage.getItem('refresh_token');

const initialState = {
    authenticated: (storedToken !== null),
    token: storedToken,
    refreshToken: storedRefreshToken,
    userData: {
        name: null,
        avatar: null
    },
    loginPending: false,
    registerPending: false,
    forgottenPasswordPending: false,
    resetPending: false,
    loginError: null,

    confirmEmailPending: false
};

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_PENDING":
            return Object.assign({}, state, {loginPending: true, loginError: null});

        case "LOGIN_FULFILLED":
            return Object.assign({}, state, {
                loginPending: false,
                token: action.payload.token,
                refreshToken: action.payload.refresh_token,
                authenticated: true,
                loginError: null
            });

        case "LOGIN_REJECTED":
            return Object.assign({}, state, {
                loginPending: false,
                loginError: "Грешен е-мейл или парола"
            });

        case "REGISTER_PENDING":
            return Object.assign({}, state, {registerPending: true});

        case "REGISTER_FULFILLED":
            //TODO not sure what should happen here
            return Object.assign({}, state, {
                registerPending: false
            });

        case "REGISTER_REJECTED":
            //TODO
            return Object.assign({}, state, {
                registerPending: false
            });

        case "FORGOT_PASSWORD_PENDING":
            return Object.assign({}, state, {
                forgottenPasswordPending: true
            });

        case "FORGOT_PASSWORD_FULFILLED":
            return Object.assign({}, state, {
                forgottenPasswordPending: false
            });

        case "FORGOT_PASSWORD_REJECTED":
            return Object.assign({}, state, {
                forgottenPasswordPending: false
            });

        case "RESET_PASSWORD_PENDING":
            return Object.assign({}, state, {
                resetPending: true
            });

        case "RESET_PASSWORD_FULFILLED":
            return Object.assign({}, state, {
                resetPending: false
            });

        case "RESET_PASSWORD_REJECTED":
            return Object.assign({}, state, {
                resetPending: false
            });

        case "CONFIRM_EMAIL_PENDING":
            return Object.assign({}, state, {
                confirmEmailPending: true
            });
        case "CONFIRM_EMAIL_FULFILLED":
            return Object.assign({}, state, {
                confirmEmailPending: false
            });

        case "CONFIRM_EMAIL_REJECTED":
            return Object.assign({}, state, {
                confirmEmailPending: false
            });

        default:
            return state;
    }
};

export default AuthReducer;


// WEBPACK FOOTER //
// ./src/reducers/Auth.js